/**
 * @generated SignedSource<<2c2e55c74beb64c53984ef0e25e39604>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivityVisibility = "AUTHENTICATED" | "MEMBERS" | "UNAUTHENTICATED";
export type UpdateEventInput = {
  banner?: any | null | undefined;
  description?: string | null | undefined;
  rules?: string | null | undefined;
  shortDescription?: string | null | undefined;
  slug?: string | null | undefined;
  thumbnail?: any | null | undefined;
  title?: string | null | undefined;
  visibility?: ActivityVisibility | null | undefined;
};
export type EventRulesPageUpdateEventMutation$variables = {
  id: string;
  input: UpdateEventInput;
};
export type EventRulesPageUpdateEventMutation$data = {
  readonly updateEvent: {
    readonly node: {
      readonly id: string;
      readonly latestRule: {
        readonly entityAgreement: {
          readonly createdAt: string;
          readonly id: string;
        } | null | undefined;
        readonly id: string;
        readonly text: string;
      };
    };
  };
};
export type EventRulesPageUpdateEventMutation = {
  response: EventRulesPageUpdateEventMutation$data;
  variables: EventRulesPageUpdateEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "updateEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRuleAgreement",
                "kind": "LinkedField",
                "name": "entityAgreement",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventRulesPageUpdateEventMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventRulesPageUpdateEventMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a7e5ab41c0342f217e4ee570557a86a8",
    "id": null,
    "metadata": {},
    "name": "EventRulesPageUpdateEventMutation",
    "operationKind": "mutation",
    "text": "mutation EventRulesPageUpdateEventMutation(\n  $id: ID!\n  $input: UpdateEventInput!\n) {\n  updateEvent(id: $id, input: $input) {\n    node {\n      id\n      latestRule {\n        id\n        text\n        entityAgreement {\n          id\n          createdAt\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e38575ab182917125b8bb71ffe56872";

export default node;
